<template>
  <div class="user-container">
    <div class="icon-container" @click="openProfileMenu">
      <i class="material-icons account-icon">account_circle</i>
    </div>

    <div
      class="notifications-container"
      @click="readNotifications"
      :class="{ 'has-count': notificationCount, 'disabled': suspensionMessage}"
    >
      <div class="bell">
        <i class="material-icons bell-icon">notifications</i>
      </div>
      <div class="count" v-if="notificationCount">{{ notificationCount }}</div>
    </div>

    <div class="points-container" :class="{'disabled': suspensionMessage}" @click="$router.push('/snaps')">
      <!-- <i class="material-icons points-icon">stars</i> -->
      <img src="/images/icons/snap.svg" class="snaps-icon" />
      <div class="points">{{ $store.state.points | bigNumber }}</div>
    </div>

    <div class="clearfix"></div>
    <notifications :events="events" v-if="showNotifications"></notifications>
    <profile-menu v-if="showProfileMenu"></profile-menu>
  </div>
</template>

<script>
import Back from "@/modules/Back";
import Notifications from "./Notifications";
import ProfileMenu from "./ProfileMenu";
import { mapGetters, mapState } from "vuex";

export default {
  name: "UserSection",
  components: { Notifications, ProfileMenu },
  data: function () {
    return {
      notificationsRead: false,
    };
  },
  watch: {
    events(to, from) {
      this.notificationsRead = false;
    },
  },
  computed: {
    ...mapGetters({
      showNotifications: "showNotifications",
      showProfileMenu: "showProfileMenu",
      suspensionMessage: "suspensionMessage",
    }),
    ...mapState({
      events: "events",
    }),
    notificationCount() {
      if (this.notificationsRead) {
        return 0;
      }
      let notificationCount = 0;
      for (const e in this.events) {
        const event = this.events[e];

        if (event.waiting_web_delivery) {
          notificationCount++;
        }
      }
      return notificationCount
    }
  },
  methods: {
    readNotifications() {
      this.$store.commit("showNotifications");
      Back.markNotificationsAsRead();
      this.notificationsRead = true;
    },
    openProfileMenu() {
      this.$store.commit("showProfileMenu");
    },
  },
};
</script>

<style lang="scss" scoped>
.snaps-icon {
  float: left;
  width: 22px;
  margin: 7px 0 0 0;
}
.user-container {
  padding: 5px 28px 9px 0px;
  border-top: 0px solid #e7e7eb;
  border-bottom: 0px solid #e7e7eb;
}
.disabled {
  background: #f4f4f4 !important;
  color: #aaa !important;
  pointer-events: none;
}
@media (max-width: 600px) {
  .user-container {
    padding-right: 12px;
    padding-top: 24px;
    zoom: 0.85;
  }
}

.icon-container {
  float: right;
  width: 35px;
  height: 35px;
  margin-left: 16px;
  background: #fff;
  border-radius: 28px;
  border: 2px solid darken($color-sidebar, 4%) !important;
  padding: 3px 0 0 4px;
  cursor: pointer;
}
.username-container {
  float: right;
}

.account-icon {
  margin-top: 2px;
  color: $color-blue;
  font-size: 17pt;
}

.username {
  display: none;
  margin-top: -2px;
  color: #222;
  font-size: 14pt !important;
  font-weight: 500;
  font-family: "Source Sans Pro";
}

.notifications-container {
  float: right;
  width: 35px;
  height: 35px;
  margin-left: 16px;
  background: #fff;
  border-radius: 28px;
  border: 2px solid darken($color-sidebar, 4%) !important;
  padding: 5px 0 0 4px;
  cursor: pointer;
}
.bell {
  float: left;

  color: #2196f3 !important;
}
.bell-icon {
  font-size: 17pt !important;
}
.count {
  float: left;
  margin-top: -1px;
  margin-right: 5px;
  font-size: 12pt !important;
  min-width: 24px;
  text-align: center;
  background: #ef5350;
  padding: 0px 6px;
  border-radius: 80px;
  font-weight: 600;
  font-family: $font-family;
  color: #fff;
}
.notifications-container.has-count {
  width: auto !important;
}

.points-container {
  float: right;
  background: #fff;
  border-radius: 28px;
  border: 2px solid darken($color-sidebar, 4%) !important;
  padding: 3px 10px 0 8px;
  cursor: pointer;
}
.is-friend .points-container {
  opacity: 0;
}
.points-icon {
  float: left;
  color: $color-snaps;
  font-size: 18pt !important;
}
.points {
  float: left;
  margin-top: -0px;
  padding-top: 0px !important;
  color: darken($color-snaps, 0%);
  margin-left: 5px;
  font-size: 13pt !important;
  font-weight: 600;
  font-family: "Source Sans Pro";
}
.clearfix {
  clear: both;
}
</style>